import React from 'react';
import './note-editor.css';
import {
    EditorComposer,
    Editor,
    ToolbarPlugin,
    BackgroundColorPicker,
    BoldButton,
    CodeFormatButton,
    InsertDropdown,
    InsertLinkButton,
    ItalicButton,
    TextColorPicker,
    TextFormatDropdown,
    UnderlineButton,
    Divider,
} from 'verbum';

const NoteViewer = ({ initialEditorState, onChange }) => {
    return (
        <EditorComposer initialEditorState={initialEditorState}>
            <Editor
                hashtagsEnabled={false}
                emojisEnabled={true}
                emojiPickerEnabled={true}
                placeholder="Start writing your note..."
                actionsEnabled = {true}
                autoLinkEnabled={true}
                onChange={onChange}
            >

                <ToolbarPlugin defaultFontSize="20px" defaultBgColor={'#16171e'} defaultTextColor={'#F9FAFB'}>
                    {/*<FontFamilyDropdown fontOptions={defaultFontFamilyOptions}/>*/}
                    {/*<FontSizeDropdown fontSizeOptions={defaultFontSizeOptions}/>*/}
                    {/*.toolbar select.toolbar-item { padding: 0 !important; }*/}
                    <Divider />
                    <BoldButton />
                    <ItalicButton />
                    <UnderlineButton />
                    <CodeFormatButton />
                    <InsertLinkButton />
                    <TextColorPicker />
                    <BackgroundColorPicker />
                    <TextFormatDropdown />
                    <Divider />
                    <InsertDropdown enablePoll={true} />
                    <Divider />
                </ToolbarPlugin>
            </Editor>
        </EditorComposer>
    );
};

export default NoteViewer;